import "./about.css";

import MyPic2 from "../../assets/MyPic2.png";
import { aboutCards } from "../../utils/websiteData";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about-container">
        <div className="about-me">
          <div className="about-image">
            <div className="planets"></div>
            <img src={MyPic2} alt="my-pic" />
          </div>
        </div>
        <div className="about-content">
          <div className="about-cards">
            {aboutCards.map((card, index) => {
              const { icon, title, desc } = card;
              return (
                <article key={index} className="about-card">
                  {icon}
                  <h5>{title}</h5>
                  <small>{desc}</small>
                </article>
              );
            })}
          </div>
          <p>
            I am a creative designer and developer, who aims to work with small
            businesses and marginalized communities to bring their passions to
            life. I offer both design and development services of web
            applications or websites!
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};
export default About;
